import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../api/client.js";

const EMPTY_SETTINGS = Object.freeze({
  phoneNumbers: [],
  emailAddresses: [],
  businessAddress: "",
  socialLinks: {
    facebook: "",
    instagram: "",
    pinterest: "",
    youtube: "",
  },
});

const SiteSettingsContext = createContext({
  settings: EMPTY_SETTINGS,
  loading: true,
});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(EMPTY_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    api.siteSettings
      .get({ signal: controller.signal })
      .then((response) =>
        setSettings({
          ...EMPTY_SETTINGS,
          ...response.data,
          socialLinks: {
            ...EMPTY_SETTINGS.socialLinks,
            ...response.data.socialLinks,
          },
        }),
      )
      .catch((error) => {
        if (error.name !== "AbortError" && process.env.NODE_ENV === "development") {
          console.error("Could not load public site settings", error);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, []);

  const value = useMemo(() => ({ settings, loading }), [settings, loading]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
